module.exports = __webpack_public_path__ + "img/9c53f39.png";